// extracted by mini-css-extract-plugin
module.exports = {"container":"Total__container___rOA8T","isLoading":"Total__isLoading___QZ+qR","iconChevron":"Total__iconChevron___40P32"};